import { 
    GoogleAuthProvider, 
    signInWithPopup,
    signInWithRedirect,
    getRedirectResult,
    signOut, setPersistence, browserLocalPersistence, onAuthStateChanged
  } from "firebase/auth";
  import { auth } from "./config";
  import store from '../store';
  
  export const initializeAuth = async () => {
    try {
      await setPersistence(auth, browserLocalPersistence);
      console.log("Firebase auth persistence set to local storage.");
    } catch (error) {
      console.error("Error setting auth persistence:", error);
    }
  };
  
  // Optional: helper to get current user when Firebase loads
  export const listenForAuthChanges = (callback) => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        callback(user);
      } else {
        callback(null);
      }
    });
  };
  // Create a Google Auth Provider
  const googleProvider = new GoogleAuthProvider();
  
  // Sign in with Google using Popup (better for desktop)
  export const signInWithGooglePopup = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      // This gives you a Google Access Token
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      // The signed-in user info
      const user = result.user;
      
      // Save auth data to local storage
      //localStorage.setItem('user', JSON.stringify(user));
      const idToken = await result.user.getIdToken(true);
      localStorage.setItem('token', idToken);
      
      // Save user to Vuex store
      //store.dispatch('login', user);
      
      return { user, token };
    } catch (error) {
      console.error("Error signing in with Google:", error);
      throw error;
    }
  };
  
  // Sign in with Google using Redirect (better for mobile)
  export const signInWithGoogleRedirect = () => {
    try {
      return signInWithRedirect(auth, googleProvider);
    } catch (error) {
      console.error("Error starting Google redirect flow:", error);
      throw error;
    }
  };
  
  // Handle redirect result (call this on component mount)
  export const handleRedirectResult = async () => {
    try {
      const result = await getRedirectResult(auth);
      if (result) {
        // Get credentials, token, and user data
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        const user = result.user;
        
        // Save auth data to local storage
        localStorage.setItem('user', JSON.stringify(user));
        const idToken = await result.user.getIdToken(true);
        localStorage.setItem('token', idToken);
        
        // Save user to Vuex store
        //store.dispatch('login', user);
        
        return { user, token };
      }
      return null;
    } catch (error) {
      console.error("Error handling redirect result:", error);
      throw error;
    }
  };
  
  // Get current user from local storage
  export const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  };
  
  // Get authentication token from local storage
  export const getToken = () => {
    return localStorage.getItem('token');
  };
  
  // Sign out user
  export const signOutUser = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      // Clear user from Vuex store
      store.dispatch('logout');
    } catch (error) {
      console.error("Error signing out:", error);
      throw error;
    }
  };
  
  // Verify token with backend
  export const verifyToken = async () => {
    const token = getToken();
    if (!token) return { valid: false, user: null };
    
    try {
      // Use relative URL that will work in any environment
      const response = await fetch('/api/auth/google', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });
      console.log("response", response)
      const data = await response.json();
      data.valid = response.status === 200 ? true : false
      if (data.valid && data.user) {
        // Update local storage with the latest user info from the server
        //localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem("AUTH_TOKEN", data.token)
        // Update Vuex store with the latest user info
        store.dispatch('login', data.user);
      } else {
        // If token is invalid, clear the store
        store.dispatch('logout');
      }
      
      return data;
    } catch (error) {
      console.error("Error verifying token:", error);
      return { valid: false, error: "Network error" };
    }
  };